export default __webpack_public_path__ + "static/media/Rubik-Italic-VariableFont_wght.ede281d4.ttf";